import { useTranslation } from "react-i18next";

import { PriceBreakdownTable } from "@/components/Portal/DeviceManagement/SubscriptionDetails/SubscriptionDisplay/SubscriptionPrice/PriceBreakdownTable";
import { useSubscriptionPriceBreakdown } from "@/components/Portal/DeviceManagement/SubscriptionDetails/SubscriptionDisplay/SubscriptionPrice/useSubscriptionPriceBreakdown";

/**
 * What the next bill looks like once auto-renewal is switched back on - shared
 * by the subscription and Watch SIM "enable auto-renewal" screens.
 */
export const AutoRenewalBillPreview = ({
  title,
  description,
  breakdown,
  minContractDuration,
  nextBillDate,
}: {
  title: string;
  description: string;
  breakdown: ReturnType<typeof useSubscriptionPriceBreakdown>;
  minContractDuration?: number;
  nextBillDate?: string;
}) => {
  const { t } = useTranslation("portal");
  const { t: tDefault } = useTranslation();

  return (
    <>
      <div className="flex w-full flex-col gap-2">
        <p className="text-body-sm font-semibold text-foreground-primary">
          {title}
        </p>
        <p className="text-body-sm text-foreground-secondary">{description}</p>
      </div>

      <PriceBreakdownTable
        breakdown={breakdown}
        interval={t("cockpit.managementTile.tariff.payInterval", {
          days: minContractDuration ?? 30,
        })}
        // Without a known bill date, say nothing rather than guess -
        // the interval in the value column still carries the total.
        totalLabel={
          nextBillDate
            ? tDefault("portal:common.autoRenewal.dueDate", {
                date: nextBillDate,
              })
            : ""
        }
      />
    </>
  );
};
